import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { PyramidalShareholderFormComponent } from '../pyramidal-shareholder-form/pyramidal-shareholder-form.component';
import { PyramidalShareholderService } from '../../../services/pyramidal-shareholder.service';
import { CreatePyramidalShareholderRequest } from '../../../models/api/createPyramidalShareholderRequest';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HotToastService } from '@ngxpert/hot-toast';

@Component({
  selector: 'app-pyramidal-shareholder-create',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, PyramidalShareholderFormComponent, NgxSpinnerModule],
  templateUrl: './pyramidal-shareholder-create.component.html',
  styleUrls: ['./pyramidal-shareholder-create.component.scss']
})
export class PyramidalShareholderCreateComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private pyramidalShareholderService: PyramidalShareholderService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private toast: HotToastService
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      category: ['', Validators.required],
      subcategory: [''],
      notes: ['']
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.spinnerService.show();

      const formValue = this.form.value;
      const request: CreatePyramidalShareholderRequest = {
        name: formValue.name,
        categoryId: formValue.category?.id || formValue.category,
        subCategoryId: formValue.subcategory?.id || formValue.subcategory || '',
        notes: formValue.notes || ''
      };

      this.pyramidalShareholderService.createPyramidalShareholder(request).subscribe({
        next: () => {
          this.spinnerService.hide();
          this.toast.success('Pyramidal shareholder created successfully', {
            iconTheme: {
              primary: 'var(--mat-sys-primary)',
              secondary: '#FFF',
            }
          });
          this.router.navigate(['/pyramidal-shareholders/list']);
        },
        error: (error: Error) => {
          this.spinnerService.hide();
          this.toast.error('Error creating pyramidal shareholder', {
            iconTheme: {
              primary: 'var(--mat-sys-error)',
              secondary: '#FFF',
            }
          });
          console.error('Error creating pyramidal shareholder:', error);
        }
      });
    }
  }

  onCancel() {
    this.router.navigate(['/pyramidal-shareholders/list']);
  }
}
